/* eslint-disable */
import { db } from "../firebase";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";

export function lockdownRef(schoolId) {
  return doc(db, "schools", schoolId, "security", "lockdown");
}

export async function getSecurityLockdown(schoolId) {
  if (!schoolId) return null;

  const snap = await getDoc(lockdownRef(schoolId));
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}

async function writeSecurityAuditLog(
  schoolId,
  action,
  metadata = {}
) {
  try {
    await addDoc(
      collection(
        db,
        "schools",
        schoolId,
        "auditLogs"
      ),
      {
        type: "security_lockdown",
        action,
        metadata,
        createdAt: serverTimestamp(),
      }
    );
  } catch (error) {
    console.error(
      "Failed to write security audit log:",
      error
    );
  }
}

export async function enableSecurityLockdown({
  schoolId,
  reason,
  enabledBy,
  enabledByEmail,
}) {
  if (!schoolId) throw new Error("Missing school ID.");

  await setDoc(
    lockdownRef(schoolId),
    {
      enabled: true,
      reason: reason || "Security incident mode enabled",
      enabledBy: enabledBy || "",
      enabledByEmail: enabledByEmail || "",
      enabledAt: serverTimestamp(),

      disabledBy: "",
      disabledByEmail: "",
      disabledAt: null,

      disableAdminLogin: true,
      freezeSensitiveActions: true,
      freezeEvidence: true,
      freezeInvites: true,
      freezeBroadcasts: true,
      freezeExports: true,
      revokeSessions: true,

      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
  await writeSecurityAuditLog(
  schoolId,
  "lockdown_enabled",
  {
    reason,
    enabledBy,
    enabledByEmail,
  }
);
}

export async function disableSecurityLockdown({
  schoolId,
  disabledBy,
  disabledByEmail,
}) {
  if (!schoolId) throw new Error("Missing school ID.");

  await setDoc(
    lockdownRef(schoolId),
    {
      enabled: false,
      reason: "",

      disabledBy: disabledBy || "",
      disabledByEmail: disabledByEmail || "",
      disabledAt: serverTimestamp(),

      disableAdminLogin: false,
      freezeSensitiveActions: false,
      freezeEvidence: false,
      freezeInvites: false,
      freezeBroadcasts: false,
      freezeExports: false,
      revokeSessions: false,

      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
  await writeSecurityAuditLog(
  schoolId,
  "lockdown_disabled",
  {
    disabledBy,
    disabledByEmail,
  }
);
}

export function isLockdownActive(lockdown) {
  return !!lockdown?.enabled;
}

export function isSensitiveActionFrozen(lockdown) {
  return !!lockdown?.enabled && !!lockdown?.freezeSensitiveActions;
}

export function isEvidenceFrozen(lockdown) {
  return !!lockdown?.enabled && !!lockdown?.freezeEvidence;
}